import { connect } from 'react-redux';
import { compose } from 'redux';
import { Dispatch } from 'redux-api-middleware';

import { ReportsResponse } from '../../../store/api/reports/reports.types';
import { fetchReports } from '../../../store/api/reports/reportsActions';

import { Reports } from './Reports';

const mapDispatchToProps = (dispatch: Dispatch) => ({
  onFetchReports: () => dispatch<Promise<ReportsResponse>>(fetchReports()),
});

export const ReportsContainer = compose(
  connect(
    undefined,
    mapDispatchToProps,
  ),
)(Reports);
